import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import {  PortalsRoutes  } from "../../../routes/HomeRoutes/PortalsRoutes";

export const PortalLayout = () => (
    <SwitchRoute routes={PortalsRoutes}/>
);